var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BlBackdrop",
    {
      attrs: { title: "Duplicate draft from past session", footer: false },
      on: {
        "backdrop-close": function($event) {
          return _vm.$emit("close-modal")
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-col gap-4 px-8 pb-8 w-200" },
        [
          _c("BlTextBody2", {
            attrs: {
              text:
                "Select any of your last 50 sessions to automatically add all its targets to your current draft."
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "flex" }, [
            _c(
              "div",
              {
                staticClass: "relative pr-5 overflow-y-auto w-100",
                style: { height: "calc(100vh - 20rem)" }
              },
              [
                _c(
                  "div",
                  { staticClass: "sticky top-0 z-10 pb-3 bg-pure-white" },
                  [
                    _c("BlInputSearch", {
                      attrs: { input: _vm.searchInput },
                      on: { changed: _vm.onInputSearch }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.fetchLoading
                  ? _c(
                      "div",
                      { staticClass: "grid my-32 place-items-center" },
                      [_c("div", { staticClass: "blum-loader-sm" })]
                    )
                  : _vm._l(_vm.sessions, function(session) {
                      return _c(
                        "div",
                        {
                          key: session.id,
                          staticClass:
                            "flex gap-2 px-3 py-2 border-b cursor-pointer border-slate-400",
                          on: {
                            click: function($event) {
                              return _vm.onSelectSession(session)
                            }
                          }
                        },
                        [
                          _c("BlInputRadio", {
                            attrs: {
                              name: "session_" + session.id,
                              checked: _vm.selectedSessionId === session.id
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex flex-col gap-1" },
                            [
                              _c("BlTextBody2", {
                                attrs: {
                                  text: session.name || "Unnamed session"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex items-center gap-1" },
                                [
                                  _c("BlTextBody3", {
                                    attrs: { text: "ID " + session.id }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "flex-shrink-0 w-1 h-1 rounded-full bg-slate-300"
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody3", {
                                    attrs: {
                                      text:
                                        session.number_of_measurements +
                                        " target(s)"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "px-5 pb-3 overflow-y-auto w-100 bg-slate-200",
                style: { height: "calc(100vh - 20rem)" }
              },
              [
                !_vm.selectedSessionId
                  ? _c(
                      "div",
                      { staticClass: "flex justify-center my-32" },
                      [
                        _c("BlTextBody2", {
                          attrs: {
                            text: "Select a session to preview the targets"
                          }
                        })
                      ],
                      1
                    )
                  : _c("div", [
                      _c(
                        "div",
                        { staticClass: "sticky top-0 z-10 py-3 bg-slate-200" },
                        [
                          _c("BlTextBody2", {
                            attrs: {
                              text:
                                "Preview " +
                                _vm.selectedSessionData.number_of_measurements +
                                " target(s)"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.measurementLoading
                        ? _c(
                            "div",
                            { staticClass: "flex justify-center my-32" },
                            [_c("div", { staticClass: "blum-loader-sm" })]
                          )
                        : !_vm.measurements.length
                        ? _c(
                            "div",
                            { staticClass: "flex justify-center my-32" },
                            [
                              _c("BlTextBody2", {
                                attrs: { text: "Target(s) not found." }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col" },
                        _vm._l(_vm.measurements, function(measurement) {
                          return _c("TargetCard", {
                            key: measurement.id,
                            class: {
                              "my-2":
                                measurement.target.target_tasks &&
                                measurement.target.target_tasks.length > 0
                            },
                            attrs: {
                              isFromSession: true,
                              target: measurement.target
                            }
                          })
                        }),
                        1
                      )
                    ])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex items-center justify-end gap-4" },
            [
              _c("BlInputButton", {
                attrs: { type: "plain", label: "Cancel" },
                on: {
                  clicked: function($event) {
                    return _vm.$emit("close-modal")
                  }
                }
              }),
              _vm._v(" "),
              _c("BlInputButton", {
                attrs: {
                  label: "Use Session ID " + _vm.selectedSessionId,
                  disabled:
                    !_vm.selectedSessionId ||
                    (_vm.selectedSessionData &&
                      _vm.selectedSessionData.number_of_measurements === 0),
                  loading: _vm.submitLoading
                },
                on: { clicked: _vm.onDuplicate }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45d3c0f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45d3c0f2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sessions/draft/DuplicateSessionModal.vue
// module id = null
// module chunks = 